import styled, { css } from 'styled-components';
import { mq, getSpace, borderShape } from '../../../stylesheets/tools';

const disabledColor = 'gray';

const StyledButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  appearance: none;
  border: 0;
  background: transparent;
  cursor: pointer;
  color: inherit;
  text-transform: uppercase;
  margin-right: ${getSpace('s')};
  /* Override padding right if arrow is right */
  padding-right: ${props => (!props.arrowLeft ? getSpace('s') : '')};

  ${mq('m')} {
    /* Override padding right if arrow left */
    padding-right: ${props => (!props.arrowLeft ? getSpace('l') : '')};
  }

  ${props =>
    !props.noBorder &&
    css`
      padding: ${getSpace('xs')};
      ${borderShape('black', 'grey', 'grey')}
    `}
  [data-whatinput='mouse'] &,
  [data-whatinput='touch'] & {
    outline: 0;
  }

  .button__arrowLong,
  .button__arrow {
    margin-right: ${props => (props.arrowLeft ? getSpace('xxs') : null)};

    ${props =>
      !props.arrowLeft &&
      css`
        position: absolute;
        right: -20px;
      `}
    svg {
      width: 30px;

      ${mq('m')} {
        width: 50px;
      }
    }
  }

  .button__arrowLong {
    display: none;

    ${mq('m')} {
      display: block;
    }
  }

  .button__arrow {
    ${mq('m')} {
      display: none;
    }
  }

  &[disabled] {
    color: ${disabledColor};
    border-color: ${disabledColor};
    pointer-events: none;

    ${props =>
      !props.noBorder &&
      css`
        ${mq('m')} {
          ${borderShape(disabledColor, 'grey')}
        }
      `}
  }
`;

export default StyledButton;
